import {
  Tooltip,
  TooltipAnchor,
  TooltipArrow,
  TooltipProvider,
} from "@replicate/ui";
import ConditionalWrap from "./conditional-wrap";

export default function TextTooltip({
  anchorText,
  tooltipText,
  tooltipClass = "",
  anchorClass = "",
  placement = "top",
  anchorHref,
}: {
  anchorText: string;
  tooltipText: React.ReactNode;
  tooltipClass?: string;
  anchorClass?: string;
  anchorHref?: string;
  placement?: "top" | "bottom" | "left" | "right";
}) {
  return (
    <TooltipProvider placement={placement} showTimeout={0}>
      <TooltipAnchor
        className={`${
          anchorHref ? "" : "underline cursor-help decoration-dotted"
        } ${anchorClass}`}
      >
        <ConditionalWrap
          condition={!!anchorHref}
          wrap={(children) => (
            <a href={anchorHref} className="text-r8-sm">
              {children}
            </a>
          )}
        >
          <span>{anchorText}</span>
        </ConditionalWrap>
      </TooltipAnchor>
      <Tooltip className={`max-w-48 text-r8-xs z-50 ${tooltipClass}`}>
        <TooltipArrow />
        {tooltipText}
      </Tooltip>
    </TooltipProvider>
  );
}
